<div
  class="input-money__container"
  [ngClass]="{
    'input--disabled': disabled,
    'input--error': isError
  }"
>
  <label class="input__label" *ngIf="label">{{ label }}</label>
  <input
    type="text"
    class="input__input input--fluid"
    [ngClass]="{ 'input__input--focus': setInputAsFocused }"
    [placeholder]="placeholder"
    [disabled]="disabled || null"
    [mask]="'separator.' + (restrictToIntegers ? 0 : value < 1 ? 3 : 2)"
    separatorLimit="{{ max }}"
    thousandSeparator=","
    [prefix]="prefix"
    [suffix]="suffix"
    [ngModel]="value === undefined ? null : value"
    (ngModelChange)="handleValueChange($event)"
    [attr.data-recording-sensitive]="sensitive || null"
  />
  <div
    class="input-money__stepper"
    *ngIf="addSteppers"
    [ngClass]="{ 'input-money__stepper--disabled': disabled }"
  >
    <button
      type="button"
      class="input-money__stepper--substract"
      #substractStepper
    ></button>
    <button
      type="button"
      class="input-money__stepper--add"
      #addStepper
    ></button>
  </div>
  <div class="input__message">
    <ng-content></ng-content>
  </div>
</div>
